import { render, staticRenderFns } from "./TaskCreateModal.vue?vue&type=template&id=0da52800&scoped=true"
import script from "./TaskCreateModal.vue?vue&type=script&lang=ts"
export * from "./TaskCreateModal.vue?vue&type=script&lang=ts"
import style0 from "./TaskCreateModal.vue?vue&type=style&index=0&id=0da52800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da52800",
  null
  
)

export default component.exports